import { selectors as authSelectors } from './reducers/Auth';
import { selectors as taskSelectors } from './reducers/Task';
import { selectors as clientSelectors } from './reducers/Client';
import { selectors as companySelectors } from './reducers/Company';
import { selectors as performanceCommentSelectors } from './reducers/PerformanceComment';
import { selectors as phoneNumberTypeSelectors } from './reducers/PhoneNumberType';
import { selectors as projectSelectors } from './reducers/Project';
import { selectors as projectStaffingSelectors } from './reducers/ProjectStaffing';
import { selectors as landmanSelectors } from './reducers/Landman';
import { selectors as userSelectors } from './reducers/User';
import { selectors as officeSelectors } from './reducers/Office';
import { selectors as layoutSelectors } from './reducers/Layout';
import { selectors as profileSelectors } from './reducers/Profile';
import { selectors as stateSelectors } from './reducers/State';
import { selectors as tractSelectors } from './reducers/Tract';
import { selectors as tagSelectors } from './reducers/Tag';
import { selectors as searchSelectors } from './reducers/Search';
import { selectors as ownerSelectors } from './reducers/Owner';
import { selectors as countySelectors } from './reducers/County';
import { selectors as leaseholdSelectors } from './reducers/Leasehold';
import { selectors as fileManagementSelectors } from './reducers/FileManagement';
import { selectors as leaseGenerationSelectors } from './reducers/LeaseGeneration';
import { selectors as personnelSelectors } from './reducers/Personnel';

export default {
    auth: { ...authSelectors },
    client: { ...clientSelectors },
    company: { ...companySelectors },
    task: { ...taskSelectors },
    phoneNumberType: { ...phoneNumberTypeSelectors },
    project: { ...projectSelectors },
    projectStaffing: { ...projectStaffingSelectors },
    landman: { ...landmanSelectors },
    performanceComments: { ...performanceCommentSelectors },
    user: { ...userSelectors },
    office: { ...officeSelectors },
    layout: { ...layoutSelectors },
    profile: { ...profileSelectors },
    state: { ...stateSelectors },
    tract: { ...tractSelectors },
    tag: { ...tagSelectors },
    search: { ...searchSelectors },
    owner: { ...ownerSelectors },
    county: { ...countySelectors },
    leasehold: { ...leaseholdSelectors },
    fileManagement: { ...fileManagementSelectors },
    leaseGeneration: { ...leaseGenerationSelectors },
    personnel: { ...personnelSelectors },
};



// WEBPACK FOOTER //
// ./src/selectors.ts